import React from 'react';

import DatasetTools from './dataset_tools';
import TimeRateControls from './time_rate_controls';
import VSFooter from './vs_footer';
import DetailPanel from './detail_panel';
import SCZoomButton from './sc_zoom_button';
import DropUp from './drop_up';
import DateLabel from './date_label';
import DateRange from './date_range';
import ar from '../languages/ar';
import { refsStore, spacecraftStore, compareStore, videoStore, datasetStore } from '../managers/globalState';

import '../../www/assets/css/footer.css';

class Footer extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			timeController: false,
			isZoomedOut: false,
			loadDropUp: false,
			videoId: null
		};

		const { get } = refsStore.stateSnapshot;
		this._compareList = get('comparison').getCompareList();

		this.close = this.close.bind(this);
	}

	close(data) {
		this.setState({ timeController: data });
	}

	componentDidMount() {
		this.scUnsubscribe = spacecraftStore.subscribeTo('isZoomedOut', zoom => this.setState({ isZoomedOut: zoom }));
		// Load DropUp when spacecraft is in view, similar to zoom button
		this.dropUpUnsubscribe = spacecraftStore.subscribeTo('spacecraftName', spacecraft => { this.setState({ loadDropUp: spacecraft !== null }); });
		this.compareUnsubscribe = compareStore.subscribeTo('compareObject', () => this.forceUpdate());
		this.videoUnsubscribe = videoStore.subscribeTo('videoId', videoId => this.setState({ videoId }));
	}

	componentWillUnmount() {
		typeof this.scUnsubscribe === 'function' && this.scUnsubscribe();
		typeof this.dropUpUnsubscribe === 'function' && this.dropUpUnsubscribe();
		typeof this.compareUnsubscribe === 'function' && this.compareUnsubscribe();
		typeof this.videoUnsubscribe === 'function' && this.videoUnsubscribe();
	}

	render() {
		const {
			isMobile,
			dataProps,
			datasetToolsRef,
			dateLabelRef,
			view,
			commonProps,
			detailPanelProps,
			datasetToolsProps,
			vsProps,
			controlsProps,
			timeRateControlsRef,
			showOnGlobe,
			showOnGlobePoI,
			showOnGlobeGmap,
			isPanelOpen,
			setPanelOpenState
		} = this.props;
		const { get } = refsStore.stateSnapshot;
		const { hasAnimation } = datasetStore.stateSnapshot;
		const { timeController, isZoomedOut, loadDropUp, videoId } = this.state;
		const { spacecraft } = detailPanelProps;
		const { instrument } = get('content').getEntityInfo(spacecraft) || {};
		const spacecraftView = view === 'spacecraft';

		const showCompareDropdown = !isZoomedOut && !instrument;

		// TODO: Split VSFooter into Vital Sign manager and Footer UI
		return (
			<div id='bottom-panel'>
				<div className='container-fluid px-0'>
					<div id='above-flexbox' className='container-fluid px-0 above-footer'>
						<DetailPanel
							{...detailPanelProps}
							isPanelOpen={isPanelOpen}
							setPanelOpenState={setPanelOpenState}
						/>

						{
							commonProps && commonProps.isMobile && !showOnGlobe && !showOnGlobePoI && !showOnGlobeGmap
							&& (
								<div id='date-label-container'>
									<DateLabel {...dataProps} />
								</div>
							)
						}

						{
							commonProps && !commonProps.isMobile && spacecraftView
							&& (
								<div className='spacecraft-options'>
									<SCZoomButton isMobile={isMobile} />
									{
										showCompareDropdown
										&& (
											<div className='compare-dropdown-container'>
												<DropUp showDropUp={loadDropUp} resetOnProperty={spacecraft} itemList={this._compareList} onItemClick={get('comparison').updateCompareObject} customPlaceholder={ar.compare_size} customResetIndex={(this._compareList.length) - 1} />
											</div>
										)
									}
								</div>
							)

						}

						{
							commonProps && !commonProps.isMobile
							&& (
								<TimeRateControls
									{...commonProps}
									ref={timeRateControlsRef}
									closeTimeControls={this.close}
									closeTimeControlsVisible={timeController}
								/>
							)
						}

						<div className='dataset-container'>
							{	!videoId
								&& (
									<DatasetTools
										{...commonProps}
										{...dataProps}
										{...datasetToolsProps}
										datasetToolsRef={datasetToolsRef}
									/>
								)}
							{
								hasAnimation && commonProps.isMobile
								&& (
									<DateRange />
								)
							}
						</div>

					</div>
					<VSFooter
						vsProps={vsProps}
						controlsProps={{
							...controlsProps,
							timeRateControlsRef
						}}
						closeTimeControls={this.close}
						closeTimeControlsVisible={timeController}
					/>
				</div>
			</div>
		);
	}
}

export default Footer;
